const developerDefinedTargetingIdList = [];
export default developerDefinedTargetingIdList;
